module.exports = __webpack_public_path__ + "img/1920_stores_img4.ed0a31ff.png";